export const environment = {
  production: false,
  name: 'collaudo',
  baseApiUrl: '/mypay/'
};
